export default function Contact() {
  return (
    <div>
      <p>Markko Junolainen</p>
      <p>markko.junolainen@gmail.com || +372 52 38 111</p>
      <p>WildWorksX OÜ - reg 14001919</p>
    </div>
  );
}
